import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import '../styles/Homepage.css';
import JoinClassModal from './JoinClassModal';
import { trackHomepageGetStartedClicked, trackScreenViewed } from '../tracking';
const Homepage = ({ onJoinSuccess }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const hasTrackedModalViewRef = useRef(false);
    useEffect(() => {
        if (!isModalOpen) {
            hasTrackedModalViewRef.current = false;
            return;
        }
        if (hasTrackedModalViewRef.current) {
            return;
        }
        hasTrackedModalViewRef.current = true;
        trackScreenViewed('student_join_code');
    }, [isModalOpen]);
    const handleGetStarted = () => {
        trackHomepageGetStartedClicked();
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleJoinChallenge = (joinCode, sessionId, eventId) => {
        console.log('Joining with code:', joinCode);
        setIsModalOpen(false);
        onJoinSuccess(joinCode, sessionId, eventId);
    };
    return (_jsxs("div", { className: "homepage", children: [_jsxs("section", { className: "hero-section", children: [_jsxs("div", { className: "hero-background", children: [_jsx("img", { src: "/assets/background-full.png", alt: "", className: "figures-bg", "aria-hidden": "true", ...{ fetchpriority: 'high' } }), _jsx("div", { className: "gradient-overlay" })] }), _jsxs("div", { className: "hero-content", children: [_jsx("div", { className: "tagline-container", children: _jsxs("h1", { className: "tagline", children: [_jsxs("span", { className: "finlit-line", children: [_jsx("img", { src: "/assets/type-decoration-1.png", alt: "", className: "type-decoration type-decoration-1", "aria-hidden": "true", ...{ fetchpriority: 'high' } }), "Finance."] }), _jsx("span", { children: "Made." }), _jsxs("span", { className: "fun-line", children: ["Fun.", _jsx("img", { src: "/assets/type-decoration-2.png", alt: "", className: "type-decoration type-decoration-2", "aria-hidden": "true", ...{ fetchpriority: 'high' } })] })] }) }), _jsxs("div", { className: "cta-container", children: [_jsx("img", { src: "/assets/hof-logo.svg", alt: "Hall of Fame", className: "hof-logo" }), _jsx("button", { className: "get-started-btn", onClick: handleGetStarted, children: "Get Started" })] })] })] }), _jsx(JoinClassModal, { isOpen: isModalOpen, onClose: handleCloseModal, onJoin: handleJoinChallenge })] }));
};
export default Homepage;
